import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Globe, Truck, Search, ShoppingBag, Menu, Star, Heart, Coffee } from 'lucide-react';
import { Button } from './components/ui/Button';
import { BookCategory } from './components/BookCategory';
import { FeatureCard } from './components/FeatureCard';
import { TestimonialCard } from './components/TestimonialCard';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-cyan-200" data-id="element-0">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 w-full border-b-2 border-cyan-200 bg-white/90 backdrop-blur-md shadow-sm" data-id="element-1">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" data-id="element-2">
          <div className="flex items-center gap-2" data-id="element-3">
            <div className="flex h-8 w-8 items-center justify-center rounded bg-gradient-to-br from-cyan-600 to-teal-600 text-white shadow-lg shadow-cyan-500/30" data-id="element-4">
              <BookOpen className="h-5 w-5" data-id="element-5" />
            </div>
            <span className="text-xl font-serif font-bold tracking-tight bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent" data-id="element-6">
              MJE-BOOKs
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8 text-sm font-semibold text-slate-700" data-id="element-7">
            <a href="#" className="hover:text-cyan-600 transition-colors" data-id="element-8">
              Novedades
            </a>
            <a href="#" className="hover:text-cyan-600 transition-colors" data-id="element-9">
              Más Vendidos
            </a>
            <a href="#" className="hover:text-cyan-600 transition-colors" data-id="element-10">
              Categorías
            </a>
            <a href="#" className="hover:text-cyan-600 transition-colors" data-id="element-11">
              Autores
            </a>
          </div>

          <div className="flex items-center gap-4" data-id="element-12">
            <button className="p-2 text-slate-700 hover:text-cyan-600 transition-colors" data-id="element-13">
              <Search className="h-5 w-5" data-id="element-14" />
            </button>
            <button className="p-2 text-slate-700 hover:text-cyan-600 transition-colors relative" data-id="element-15">
              <ShoppingBag className="h-5 w-5" data-id="element-16" />
              <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-teal-600 shadow-lg shadow-teal-500/50" data-id="element-17"></span>
            </button>
            <button className="md:hidden p-2 text-slate-700" data-id="element-18">
              <Menu className="h-5 w-5" data-id="element-19" />
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-cyan-100 via-teal-50 to-emerald-100 pt-16 pb-24 lg:pt-32 lg:pb-40" data-id="element-20">
        <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1507842217121-9e96e4763672?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center mix-blend-multiply" data-id="element-21"></div>
        <div className="absolute top-20 right-10 h-72 w-72 rounded-full bg-cyan-400/30 blur-3xl" data-id="element-22"></div>
        <div className="absolute bottom-20 left-10 h-96 w-96 rounded-full bg-teal-400/20 blur-3xl" data-id="element-23"></div>

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative" data-id="element-24">
          <div className="mx-auto max-w-3xl text-center" data-id="element-25">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-26">
              <span className="mb-6 inline-block rounded-full bg-gradient-to-r from-cyan-600 to-teal-600 px-5 py-2 text-sm font-bold text-white shadow-lg shadow-cyan-500/30" data-id="element-27">
                Tu librería universal online
              </span>
              <h1 className="mb-6 text-5xl font-serif font-bold tracking-tight text-slate-900 sm:text-6xl lg:text-7xl" data-id="element-28">
                Descubre historias que{' '}
                <span className="bg-gradient-to-r from-cyan-600 via-teal-600 to-emerald-600 bg-clip-text text-transparent italic" data-id="element-29">
                  trascienden
                </span>{' '}
                fronteras
              </h1>
              <p className="mb-10 text-lg text-slate-700 sm:text-xl leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-30">
                En MJE-BOOKs conectamos lectores con la literatura universal.
                Desde clásicos atemporales hasta las voces contemporáneas más
                relevantes.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-31">
                <Button size="lg" rightIcon={<BookOpen className="h-5 w-5" data-id="element-33" />} data-id="element-32">
                  Explorar Catálogo
                </Button>
                <Button variant="outline" size="lg" data-id="element-34">
                  Nuestras Recomendaciones
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-white" data-id="element-35">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-36">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-37">
            <FeatureCard icon={Globe} title="Catálogo Universal" description="Acceso a millones de títulos en múltiples idiomas y de todas las partes del mundo." delay={0.1} data-id="element-38" />
            <FeatureCard icon={Truck} title="Envío Internacional" description="Llevamos tus historias favoritas a la puerta de tu casa, estés donde estés." delay={0.2} data-id="element-39" />
            <FeatureCard icon={Heart} title="Curaduría Experta" description="Selecciones mensuales realizadas por nuestros expertos bibliófilos." delay={0.3} data-id="element-40" />
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-24 bg-gradient-to-b from-slate-50 to-cyan-50" data-id="element-41">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-42">
          <div className="mb-12 flex items-end justify-between" data-id="element-43">
            <div data-id="element-44">
              <h2 className="text-3xl font-serif font-bold text-slate-900 sm:text-4xl" data-id="element-45">
                Explora por Género
              </h2>
              <p className="mt-2 text-slate-700 font-medium" data-id="element-46">
                Encuentra tu próxima aventura literaria.
              </p>
            </div>
            <a href="#" className="hidden text-sm font-bold text-cyan-600 hover:text-cyan-700 sm:block" data-id="element-47">
              Ver todas las categorías &rarr;
            </a>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-48">
            <BookCategory title="Clásicos Universales" description="Obras maestras que han resistido la prueba del tiempo." image="https://images.unsplash.com/photo-1474932430478-367dbb6832c1?q=80&w=800&auto=format&fit=crop" count="1,200+" delay={0.1} data-id="element-49" />
            <BookCategory title="Ficción Contemporánea" description="Las voces más relevantes de la literatura actual." image="https://images.unsplash.com/photo-1512820790803-83ca734da794?q=80&w=800&auto=format&fit=crop" count="850+" delay={0.2} data-id="element-50" />
            <BookCategory title="Ciencia y Pensamiento" description="Libros para expandir tu mente y comprender el mundo." image="https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?q=80&w=800&auto=format&fit=crop" count="600+" delay={0.3} data-id="element-51" />
          </div>

          <div className="mt-8 text-center sm:hidden" data-id="element-52">
            <a href="#" className="text-sm font-bold text-cyan-600 hover:text-cyan-700" data-id="element-53">
              Ver todas las categorías &rarr;
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-24 bg-white" data-id="element-54">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-55">
          <div className="text-center mb-16" data-id="element-56">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-57">
              <span className="inline-block mb-4 text-sm font-bold uppercase tracking-wider text-cyan-600" data-id="element-58">
                Historias Reales
              </span>
              <h2 className="text-3xl font-serif font-bold text-slate-900 sm:text-4xl mb-4" data-id="element-59">
                Vidas transformadas por la lectura
              </h2>
              <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-60">
                Descubre cómo nuestros clientes encontraron inspiración,
                conocimiento y cambio a través de los libros.
              </p>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-61">
            <TestimonialCard name="María González" location="Madrid, España" image="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop" quote="Después de leer 'El Alquimista', dejé mi trabajo corporativo y perseguí mi sueño de ser escritora. Hoy publiqué mi primera novela. Este libro literalmente cambió el rumbo de mi vida." book="El Alquimista - Paulo Coelho" rating={5} delay={0.1} data-id="element-62" />

            <TestimonialCard name="Carlos Mendoza" location="Buenos Aires, Argentina" image="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop" quote="Estaba pasando por una depresión profunda. 'El hombre en busca de sentido' me dio una nueva perspectiva sobre el sufrimiento y me ayudó a encontrar propósito. Ahora soy terapeuta y ayudo a otros." book="El hombre en busca de sentido - Viktor Frankl" rating={5} delay={0.2} data-id="element-63" />

            <TestimonialCard name="Ana Sofía Ruiz" location="Ciudad de México, México" image="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop" quote="Como madre soltera, 'Mujeres que corren con los lobos' me enseñó a reconectar con mi fuerza interior. Ahora lidero talleres para mujeres y he recuperado mi autoestima completamente." book="Mujeres que corren con los lobos - Clarissa Pinkola" rating={5} delay={0.3} data-id="element-64" />

            <TestimonialCard name="Diego Ramírez" location="Bogotá, Colombia" image="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop" quote="'Sapiens' expandió mi comprensión del mundo de una manera que nunca imaginé. Cambié mi carrera a antropología y ahora investigo culturas indígenas. Mi vida tiene un nuevo significado." book="Sapiens - Yuval Noah Harari" rating={5} delay={0.1} data-id="element-65" />

            <TestimonialCard name="Laura Fernández" location="Barcelona, España" image="https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop" quote="Sufría de ansiedad crónica hasta que leí 'El poder del ahora'. Aprendí a vivir en el presente y mi calidad de vida mejoró radicalmente. Ahora enseño mindfulness a otros." book="El poder del ahora - Eckhart Tolle" rating={5} delay={0.2} data-id="element-66" />

            <TestimonialCard name="Roberto Silva" location="Lima, Perú" image="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=200&auto=format&fit=crop" quote="'Padre Rico, Padre Pobre' me abrió los ojos sobre la educación financiera. Pasé de estar endeudado a tener tres negocios exitosos. Este libro fue el catalizador de mi libertad económica." book="Padre Rico, Padre Pobre - Robert Kiyosaki" rating={5} delay={0.3} data-id="element-67" />
          </div>
        </div>
      </section>

      {/* Featured Book / CTA Section */}
      <section className="py-24 bg-gradient-to-br from-cyan-900 via-teal-800 to-emerald-900 text-white overflow-hidden relative" data-id="element-68">
        <div className="absolute top-0 right-0 -mt-20 -mr-20 h-96 w-96 rounded-full bg-cyan-500/40 blur-3xl" data-id="element-69"></div>
        <div className="absolute bottom-0 left-0 -mb-20 -ml-20 h-96 w-96 rounded-full bg-teal-500/30 blur-3xl" data-id="element-70"></div>

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-71">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 items-center" data-id="element-72">
            <div className="order-2 lg:order-1" data-id="element-73">
              <div className="flex items-center gap-2 mb-6 text-cyan-300" data-id="element-74">
                <Star className="h-5 w-5 fill-current" data-id="element-75" />
                <span className="font-bold tracking-wide uppercase text-sm" data-id="element-76">
                  Libro del Mes
                </span>
              </div>
              <h2 className="mb-6 text-4xl font-serif font-bold leading-tight sm:text-5xl" data-id="element-77">
                La Guía Anti-Hinchazón
                <span className="block text-cyan-300 text-2xl mt-2 font-sans font-normal" data-id="element-78">
                  Adiós Panza, Hola Abdomen Plano
                </span>
              </h2>
              <p className="mb-8 text-lg text-cyan-100 leading-relaxed" data-id="element-79">
                Desinflámete hoy con 3 cambios simples. Alivio en 10 minutos con
                un plan simple y sin suplementos. Transforma tu bienestar
                digestivo y recupera tu confianza.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-80">
                <Button variant="secondary" size="lg" onClick={() => window.location.href = 'https://mjebook.com/checkouts/cn/hWN7hPpGc5pxeG9KCY4yPt0k/es-us?_r=AQABz7pj3WzA9yHBLReFLg6dU1KVnNEcjLeLbwG_ytHxJ7s&cart_link_id=o5cEINWv'} className="cursor-pointer" data-id="element-81">
                  Comprar Ahora
                </Button>
                <Button variant="outline" size="lg" onClick={() => window.location.href = 'https://project-tranquil-beach-594.magicpatterns.app/'} className="text-white border-2 border-cyan-400 hover:bg-cyan-500 hover:border-cyan-500 hover:text-teal-900 font-bold cursor-pointer" data-id="element-82">
                  Leer Reseña
                </Button>
              </div>
            </div>
            <div className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-83">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8
            }} className="relative" data-id="element-84">
                <div className="absolute inset-0 bg-cyan-400 blur-[60px] opacity-50 rounded-full" data-id="element-85"></div>
                <img src="https://cdn.magicpatterns.com/uploads/sRMLKbNTWxptHCZ4B7psGK/d135fca7-e6f3-4c98-aa3d-923f61a52d3b.jpg" alt="La Guía Anti-Hinchazón" className="relative rounded-lg shadow-2xl shadow-cyan-500/60 rotate-3 hover:rotate-0 transition-transform duration-500 max-w-xs sm:max-w-sm border-4 border-cyan-400" data-id="element-86" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-24 bg-gradient-to-br from-cyan-100 to-teal-100" data-id="element-87">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8" data-id="element-88">
          <Coffee className="mx-auto h-12 w-12 text-cyan-600 mb-6" data-id="element-89" />
          <h2 className="mb-4 text-3xl font-serif font-bold text-slate-900" data-id="element-90">
            Únete a nuestro club de lectura
          </h2>
          <p className="mb-8 text-slate-700 font-medium" data-id="element-91">
            Recibe recomendaciones semanales, descuentos exclusivos y noticias
            del mundo literario directamente en tu bandeja de entrada.
          </p>
          <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" onSubmit={e => e.preventDefault()} data-id="element-92">
            <input type="email" placeholder="tu@email.com" className="flex-1 rounded-md border-2 border-cyan-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-cyan-600 focus:ring-2 focus:ring-cyan-500" data-id="element-93" />
            <Button type="submit" data-id="element-94">Suscribirse</Button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t-2 border-cyan-200 py-12" data-id="element-95">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-96">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-97">
            <div className="flex items-center gap-2" data-id="element-98">
              <BookOpen className="h-6 w-6 text-cyan-600" data-id="element-99" />
              <span className="text-lg font-serif font-bold bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent" data-id="element-100">
                MJE-BOOKs
              </span>
            </div>
            <p className="text-slate-600 text-sm font-medium" data-id="element-101">
              © 2024 MJE-BOOKs. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-slate-600 font-semibold" data-id="element-102">
              <a href="#" className="hover:text-cyan-600 transition-colors" data-id="element-103">
                Instagram
              </a>
              <a href="#" className="hover:text-cyan-600 transition-colors" data-id="element-104">
                Twitter
              </a>
              <a href="#" className="hover:text-cyan-600 transition-colors" data-id="element-105">
                Facebook
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}